import axios from 'axios'
import { Message, Loading } from 'element-ui'
import store from '@/store'
import router from '../router'
import { getUserInfo } from '@/utils/auth'
import { generateCnUs } from '@/utils/i18n'
import { getLanguage } from '@/lang/index'
import '../global.js'

let loading

function loadingText () {
  if (getLanguage() === 'zh') {
    return '数据传输中……'
  }
  return 'loading……'
}

function startLoading () {
  loading = Loading.service({
    lock: true,
    text: loadingText(),
    background: 'rgba(0, 0, 0, 0.7)'
  })
}
function endLoading () {
  loading.close()
}

// create an axios instance
const service = axios.create({
  baseURL: global.BASE_URL,
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 30000 // request timeout
})

// request interceptor
service.interceptors.request.use(
  config => {
    // 在发送请求之前做些什么
    startLoading()

    var token = store.getters.token
    if (token) {
      // let each request carry token
      // ['X-Token'] is a custom headers key
      // please modify it according to the actual situation
      config.headers['token'] = token
    }
    config.headers['lang'] = generateCnUs(getLanguage())
    config.headers['appid'] = 'easyteaching_pc'
    return config
  },
  error => {
    // 处理请求错误
    endLoading()
    Message({
      message: error.message,
      type: '请求超时，请检查网络环境',
      duration: 2 * 1000
    })
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  /**
   * 如果您想获得http信息，例如头信息或状态信息
   * Please return  response => response
  */

  /**
   * 通过自定义代码确定请求状态
   * 这里只是一个例子
   * 你也可以通过HTTP状态码来判断状态
   */
  response => {
    endLoading()
    const res = response.data
    // if the custom code is not 20000, it is judged as an error.
    if (typeof res === 'object' && res.code !== 200) {
      if (!res.msg || res.msg !== 'Need Reset Password') {
        Message({
          message: res.msg || '服务器发生未知错误，请联系管理员',
          type: 'error',
          duration: 2 * 1000
        })
      }
      // 401: Token expired;
      if (res.code === 401 && res.msg === '请重新登录') {
        // to re-login
        var UserInfo = getUserInfo()
        if (UserInfo && UserInfo.roleId && UserInfo.roleId === 13) {
          router.replace({
            path: '/admission/wx/login'
          })
        } else {
          store.dispatch('user/resetToken').then(() => {
            router.replace({
              path: '/login'
            })
          })
        }
      }
    }
    return res
  },
  error => {
    endLoading()
    Message({
      message: error.message,
      type: 'error',
      duration: 2 * 1000
    })
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js